import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';

const CAMPOS = [
  ['nombre', 'Nombre'], ['descripcion', 'Descripción breve'], ['beneficio', 'Beneficio'], ['ubicacion', 'Ubicación'],
  ['info_contacto', 'Contacto'], ['telefono', 'Teléfono'], ['whatsapp', 'WhatsApp'], ['sitio_web', 'Sitio web'],
  ['descripcion_larga', 'Descripción larga'], ['detalles_beneficio', 'Servicios'], ['condiciones', 'Condiciones'],
  ['horarios', 'Horarios'], ['precios_tarifas', 'Precios'], ['imagen_principal', 'Imagen principal'],
];

const Valor = ({ v }) => {
  if (!v) return <span className="text-gray-300">—</span>;
  if (typeof v === 'string' && /^https?:\/\/.*\.(jpg|jpeg|png|webp)/i.test(v)) return <img src={v} alt="" className="h-16 rounded object-cover" />;
  return <span className="whitespace-pre-wrap break-words">{String(v).slice(0, 400)}</span>;
};

export const RuedaCompararDialog = ({ existente, propuesto, onCancel, onDecidir, busy }) => (
  <Dialog open onOpenChange={onCancel}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="rueda-comparar-dialog">
      <DialogHeader><DialogTitle>Ya existe un prestador con ese nombre</DialogTitle></DialogHeader>
      <p className="text-sm text-gray-600">Compará los datos y elegí si actualizar el existente (solo se pisan los campos que tienen valor en la importación) o crear uno nuevo.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-xs min-w-[600px]">
          <thead><tr className="text-left text-gray-500"><th className="p-2 w-32">Campo</th><th className="p-2">Existente</th><th className="p-2">Importado de la Rueda</th></tr></thead>
          <tbody>
            {CAMPOS.map(([k, l]) => {
              const distinto = (propuesto[k] || '') !== (existente[k] || '') && propuesto[k];
              return (
                <tr key={k} className={`border-t align-top ${distinto ? 'bg-amber-50' : ''}`}>
                  <td className="p-2 font-medium text-gray-600">{l}</td>
                  <td className="p-2"><Valor v={existente[k]} /></td>
                  <td className="p-2"><Valor v={propuesto[k]} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="flex flex-wrap justify-end gap-2">
        <Button variant="outline" onClick={onCancel}>Cancelar</Button>
        <Button variant="outline" disabled={busy} onClick={() => onDecidir('nuevo')} data-testid="rueda-comparar-nuevo">Crear uno nuevo</Button>
        <Button disabled={busy} onClick={() => onDecidir('actualizar', existente.id)} data-testid="rueda-comparar-actualizar">Actualizar el existente</Button>
      </div>
    </DialogContent>
  </Dialog>
);
